{
  "appTitle": "BACK OFFICE",
  "changelog": {
    "title": "Journal des modifications",
    "description": "Quoi de neuf dans le Back Office"
  },
  "errors": {
    "loadFailed": "Échec du chargement des détails."
  },
  "accessDenied": {
    "title": "Accès refusé",
    "description": "Vous n'avez pas l'autorisation d'afficher cette page.",
    "missingPermission": "Autorisation manquante : {{permission}}",
    "backToHome": "Retour"
  },
  "noAccess": {
    "title": "Aucun accès",
    "description": "Votre compte n'a pas l'autorisation d'utiliser le back-office.",
    "hint": "Contactez votre administrateur pour demander l'accès.",
    "signedInAs": "Connecté en tant que {{email}}",
    "signOut": "Se déconnecter"
  },
  "nav": {
    "management": "Gestion",
    "iam": "Identité et accès",
    "ingress": "Ingestion de données",
    "octo": "Octo",
    "hardware": "Matériel"
  },
  "home": {
    "title": "Accueil"
  },
  "users": {
    "tools": {
      "menuLabel": "Outils",
      "lastLogin": "Répartition des dernières connexions"
    },
    "lastLoginChart": {
      "title": "Répartition des dernières connexions",
      "description": "Date de dernière connexion des utilisateurs correspondant au filtre actuel.",
      "empty": "Aucune activité de connexion pour la sélection actuelle.",
      "neverNote": "Jamais connecté : {{count}}",
      "tooltipTotal": "Total"
    },
    "title": "Utilisateurs",
    "list": {
      "columns": {
        "id": "ID",
        "publicId": "ID publique",
        "userName": "Nom d'utilisateur",
        "email": "E-mail",
        "fullName": "Nom complet",
        "realm": "Domaine",
        "defaultStore": "Magasin par défaut",
        "mfa": "MFA",
        "lastLoginAt": "Dernière connexion",
        "lastAttemptAt": "Dernière tentative",
        "status": "Statut",
        "createdAt": "Créé"
      },
      "actions": {
        "activate": "Activer",
        "deactivate": "Désactiver",
        "changeStore": "Changer de magasin",
        "delete": "Supprimer l'utilisateur",
        "cannotModifySelf": "Vous ne pouvez pas désactiver ou supprimer votre propre compte"
      },
      "addUserButton": "Créer un utilisateur",
      "searchPlaceholder": "Rechercher des utilisateurs...",
      "filter": {
        "realm": "Domaine",
        "searchRealms": "Rechercher des domaines…",
        "noRealms": "Aucun domaine trouvé",
        "chain": "Chaîne",
        "searchChains": "Rechercher des chaînes…",
        "noChains": "Aucune chaîne trouvée",
        "store": "Magasin",
        "searchStores": "Rechercher des magasins…",
        "noStores": "Aucun magasin trouvé"
      }
    },
    "dialog": {
      "createTitle": "Créer un utilisateur",
      "comingSoon": "Bientôt disponible",
      "deactivateTitle": "Désactiver l'utilisateur",
      "activateTitle": "Activer l'utilisateur",
      "deactivatePrompt": "Êtes-vous sûr de vouloir désactiver",
      "activatePrompt": "Êtes-vous sûr de vouloir activer",
      "deactivateWarning": "Cet utilisateur perdra immédiatement l'accès à focalOS.",
      "deactivateConfirm": "Désactiver",
      "activateConfirm": "Activer"
    },
    "deleteDialog": {
      "title": "Supprimer l'utilisateur",
      "prompt": "Êtes-vous sûr de vouloir supprimer définitivement",
      "warning": "Cette action est irréversible.",
      "confirm": "Supprimer"
    },
    "changeStoreDialog": {
      "title": "Changer le magasin par défaut",
      "description": "Sélectionnez un nouveau magasin par défaut pour",
      "storeLabel": "Magasin par défaut",
      "selectStore": "Sélectionner un magasin",
      "searchStores": "Rechercher des magasins…",
      "noStores": "Aucun magasin trouvé",
      "removePrevious": "Retirer l'ancien magasin par défaut des magasins disponibles",
      "save": "Enregistrer"
    },
    "form": {
      "email": "E-mail",
      "username": "Nom d'utilisateur",
      "fullName": "Nom complet",
      "realm": "Domaine",
      "selectRealm": "Sélectionner un domaine",
      "searchRealms": "Rechercher des domaines…",
      "noRealms": "Aucun domaine trouvé",
      "realmChangeWarning": "Changer de domaine SSO supprimera le mot de passe de l'utilisateur de la base de données ; il sera impossible de restaurer le mot de passe d'origine.",
      "notRequired": "Non requis",
      "password": "Mot de passe",
      "passwordEditPlaceholder": "Laisser vide pour conserver l'actuel",
      "validationDisabled": "Validation désactivée",
      "validationDisabledHint": "Les membres du groupe admin peuvent définir des mots de passe sans exigences de complexité",
      "groups": "Groupes",
      "selectGroups": "Sélectionner des groupes",
      "searchGroups": "Rechercher des groupes…",
      "noGroups": "Aucun groupe trouvé",
      "defaultStore": "Magasin par défaut",
      "selectStore": "Sélectionner un magasin",
      "searchStores": "Rechercher des magasins…",
      "noStores": "Aucun magasin trouvé",
      "availableStores": "Magasins disponibles",
      "selectAvailableStores": "Sélectionner des magasins",
      "validation": {
        "required": "Obligatoire",
        "invalidEmail": "Doit être une adresse e-mail valide",
        "passwordMinLength": "Le mot de passe doit comporter au moins 8 caractères",
        "emailExists": "Un utilisateur avec cet e-mail existe déjà",
        "usernameExists": "Un utilisateur avec ce nom d'utilisateur existe déjà"
      },
      "ftFueTraining": "Formation FT FUE",
      "requirePasswordReset": "Réinitialisation du mot de passe requise",
      "flags": "Indicateurs",
      "selectFlags": "Sélectionner des indicateurs",
      "searchFlags": "Rechercher des indicateurs…",
      "noFlags": "Aucun indicateur trouvé",
      "supervisor": "Superviseur",
      "selectSupervisor": "Sélectionner un superviseur",
      "searchSupervisor": "Rechercher des personnes…",
      "noSupervisor": "Aucune personne trouvée"
    },
    "detail": {
      "profileTitle": "Profil",
      "fullName": "Nom complet",
      "groupsTitle": "Groupes",
      "permissionsTitle": "Autorisations",
      "directlyAssigned": "Attribué directement",
      "availableStores": "Magasins disponibles"
    },
    "notifications": {
      "activated": "Utilisateur \"{{name}}\" activé",
      "deactivated": "Utilisateur \"{{name}}\" désactivé",
      "created": "Utilisateur \"{{name}}\" créé",
      "updated": "Utilisateur \"{{name}}\" mis à jour",
      "deleted": "Utilisateur \"{{name}}\" supprimé",
      "createFailed": "Échec de la création de l'utilisateur"
    },
    "permissions": {
      "view": "Voir",
      "edit": "Modifier",
      "fullAccess": "Accès complet",
      "everyBackofficePermission": "Toutes les autorisations du backoffice",
      "everyPermission": "Toutes les autorisations (superutilisateur)",
      "allPermissions": "Toutes les autorisations {{section}}",
      "grantedVia": "Accordé via {{permission}}",
      "inheritedFromGroup": "Hérité du groupe « {{group}} »",
      "inheritBanner": {
        "prefix": "Cet utilisateur hérite des autorisations de",
        "suffix": "Les autorisations héritées sont affichées verrouillées et ne peuvent pas être modifiées ici."
      },
      "labels": {
        "approvals": "Approbations",
        "chains": "Chaînes",
        "regions": "Régions",
        "settings": "Paramètres",
        "activity": "Activité",
        "stores": "Magasins",
        "operations": "Opérations",
        "health": "État",
        "hardware": "Matériel",
        "schedule": "Planning",
        "cutOffTimes": "Heures limites",
        "map": "Carte",
        "chainValues": "Valeurs de chaîne",
        "storeValues": "Valeurs de magasin",
        "iam": "IAM",
        "users": "Utilisateurs",
        "groups": "Groupes",
        "vendors": "Fournisseurs",
        "permissions": "Autorisations",
        "sso": "SSO",
        "ingress": "Ingress",
        "imports": "Imports",
        "transformations": "Transformations",
        "octo": "Octo",
        "rules": "Règles",
        "visualizer": "Visualiseur",
        "action": "Action",
        "adaOrder": "AdaOrder",
        "adaPogs": "AdaPOGs",
        "backofficeLegacy": "Backoffice (hérité)",
        "developer": "Développeur",
        "exec": "Exec",
        "fieldTool": "Outil de terrain",
        "impact": "Impact",
        "messages": "Messages",
        "productRecognition": "Reconnaissance de produits",
        "psi": "PSI",
        "review": "Révision",
        "setup": "Configuration",
        "devices": "Appareils",
        "firmware": "Firmware",
        "blackhat": "Blackhat",
        "deployment": "Déploiement",
        "factoryQa": "AQ usine",
        "fieldDeployment": "Déploiement terrain",
        "fieldIms": "IMS terrain",
        "fieldMaintenanceVisit": "Visites de maintenance terrain",
        "fieldQa": "AQ terrain",
        "fieldSetup": "Configuration terrain",
        "fieldStatus": "Statut terrain",
        "fieldStore": "Commandes magasin terrain",
        "fieldTasks": "Tâches terrain",
        "ims": "Expéditions IMS",
        "imsAddresses": "Adresses IMS",
        "labelPrint": "Impression d'étiquettes",
        "opsTasks": "Tâches d'exploitation",
        "otaVersions": "Versions OTA",
        "payment": "Paiement",
        "payroll": "Paie",
        "storeAccess": "Accès aux magasins"
      }
    }
  },
  "groups": {
    "title": "Groupes",
    "list": {
      "columns": {
        "id": "ID",
        "name": "Nom",
        "description": "Description",
        "noOfUsers": "Utilisateurs",
        "createdAt": "Créé"
      },
      "addGroupButton": "Créer un groupe",
      "searchPlaceholder": "Rechercher des groupes..."
    },
    "dialog": {
      "createTitle": "Créer un groupe"
    },
    "form": {
      "name": "Nom",
      "description": "Description",
      "validation": {
        "required": "Requis",
        "nameFormat": "Utilisez des minuscules, des chiffres et des traits de soulignement (max. 32 caractères)"
      }
    },
    "notifications": {
      "created": "Groupe « {{name}} » créé",
      "updated": "Groupe « {{name}} » mis à jour"
    }
  },
  "permissions": {
    "title": "Autorisations"
  },
  "visualizer": {
    "title": "Visualiseur"
  },
  "sso": {
    "title": "Authentification unique",
    "pageTitle": "Authentification unique — Domaines"
  },
  "vendors": {
    "title": "Fournisseurs",
    "list": {
      "columns": {
        "id": "ID",
        "name": "Nom",
        "apiKey": "Clé API",
        "chain": "Chaîne",
        "status": "Statut",
        "createdAt": "Créé le"
      },
      "searchPlaceholder": "Rechercher des fournisseurs...",
      "filter": {
        "chain": "Chaîne",
        "searchChains": "Rechercher des chaînes…",
        "noChains": "Aucune chaîne trouvée"
      },
      "actions": {
        "activate": "Activer",
        "deactivate": "Désactiver"
      },
      "addVendorButton": "Créer un fournisseur"
    },
    "notifications": {
      "activated": "Fournisseur \"{{name}}\" activé",
      "deactivated": "Fournisseur \"{{name}}\" désactivé",
      "created": "Fournisseur \"{{name}}\" créé"
    },
    "dialog": {
      "deactivateTitle": "Désactiver le fournisseur",
      "activateTitle": "Activer le fournisseur",
      "deactivatePrompt": "Êtes-vous sûr de vouloir désactiver",
      "activatePrompt": "Êtes-vous sûr de vouloir activer",
      "deactivateWarning": "Ce fournisseur perdra immédiatement l'accès aux API d'ingress et d'export.",
      "deactivateConfirm": "Désactiver",
      "activateConfirm": "Activer",
      "createTitle": "Créer un fournisseur",
      "createdTitle": "Fournisseur créé",
      "createdWarning": "Copiez la clé privée maintenant — elle ne sera plus affichée.",
      "apiKeyLabel": "Clé API",
      "privateKeyLabel": "Clé privée"
    },
    "form": {
      "name": "Nom",
      "chain": "Chaîne",
      "selectChain": "Sélectionner une chaîne",
      "searchChains": "Rechercher des chaînes…",
      "noChains": "Aucune chaîne trouvée",
      "validation": {
        "required": "Obligatoire",
        "nameMaxLength": "Le nom doit comporter au plus 32 caractères",
        "nameFormat": "Seuls les lettres minuscules, les chiffres et les traits de soulignement sont autorisés"
      }
    },
    "usage": {
      "kind": {
        "ingress": "Ingestion",
        "export": "Export"
      },
      "columns": {
        "id": "ID",
        "usage": "Utilisation",
        "type": "Type",
        "store": "Magasin",
        "chain": "Chaîne",
        "source": "Source",
        "status": "Statut",
        "createdAt": "Créé le"
      },
      "storeDeleted": "{{id}} (supprimé)"
    }
  },
  "ingressImports": {
    "title": "Imports"
  },
  "transformations": {
    "title": "Transformations",
    "list": {
      "columns": {
        "id": "ID",
        "name": "Nom",
        "key": "Clé",
        "target": "Cible",
        "outputTypes": "Types de sortie",
        "status": "Statut",
        "createdAt": "Créé"
      },
      "addButton": "Créer une transformation",
      "searchPlaceholder": "Rechercher des transformations...",
      "actions": {
        "activate": "Activer",
        "deactivate": "Désactiver",
        "viewSessions": "Voir les sessions"
      },
      "filter": {
        "chain": "Chaîne",
        "store": "Magasin"
      }
    },
    "dialog": {
      "createTitle": "Créer une transformation",
      "comingSoon": "Bientôt disponible",
      "deactivateTitle": "Désactiver la transformation",
      "activateTitle": "Activer la transformation",
      "deactivatePrompt": "Êtes-vous sûr de vouloir désactiver",
      "activatePrompt": "Êtes-vous sûr de vouloir activer",
      "deactivateWarning": "Avant de désactiver la transformation, vérifiez qu'elle n'est pas utilisée dans les importeurs SFTP/Email.",
      "deactivateConfirm": "Désactiver",
      "activateConfirm": "Activer"
    },
    "detail": {
      "title": "Détails de la transformation",
      "comingSoon": "Bientôt disponible",
      "tabs": {
        "info": "Infos",
        "files": "Fichiers",
        "sql": "SQL",
        "activityLog": "Activité"
      },
      "fields": {
        "id": "ID",
        "shortName": "Nom court",
        "description": "Description",
        "target": "Cible",
        "outputTypes": "Types de sortie",
        "perStore": "Par magasin",
        "onlyLiveStores": "Magasins actifs uniquement",
        "status": "Statut",
        "createdAt": "Créé",
        "inputFiles": "Fichiers d'entrée",
        "yes": "Oui",
        "no": "Non",
        "updatedAt": "Mis à jour",
        "sqlContent": "Requête SQL",
        "sqlContentLabel": "Contenu SQL",
        "copyToClipboard": "Copier",
        "noFiles": "Aucun fichier d'entrée défini",
        "noSql": "Pas de contenu SQL",
        "fileType": "Type de fichier",
        "exampleFileName": "Fichier exemple",
        "variesPerStore": "Varie par magasin",
        "regex": "Regex",
        "forcedFix": "Correction forcée",
        "loadExtras": "Options de chargement",
        "validateColumns": "Colonnes validées",
        "checkDate": "Vérification de date",
        "targetName": "Nom cible"
      }
    }
  },
  "rules": {
    "title": "Règles"
  },
  "chains": {
    "title": "Chaînes",
    "tabs": {
      "info": "Infos",
      "edit": "Modifier",
      "settings": "Paramètres",
      "regions": "Régions",
      "stores": "Magasins",
      "cutOffTimes": "Heures limites",
      "imports": "Importations",
      "activityLog": "Activité"
    },
    "list": {
      "columns": {
        "id": "ID",
        "legibleName": "Nom",
        "chainName": "Clé",
        "timezone": "Fuseau horaire",
        "numberOfStores": "Magasins",
        "status": "Statut"
      },
      "actions": {
        "duplicate": "Dupliquer",
        "compareSettings": "Comparer les paramètres"
      },
      "searchPlaceholder": "Rechercher des chaînes...",
      "filter": {},
      "addChainButton": "Créer une chaîne"
    },
    "form": {
      "legibleName": "Nom d'affichage",
      "chainName": "Nom de la chaîne",
      "defaultTimeZone": "Fuseau horaire par défaut",
      "copySettings": "Copier les paramètres d'une chaîne existante",
      "selectTimezone": "Sélectionner un fuseau horaire",
      "searchTimezones": "Rechercher des fuseaux horaires…",
      "noTimezones": "Aucun fuseau horaire trouvé",
      "selectCopyFrom": "Sélectionner une chaîne source",
      "searchCopyFrom": "Rechercher des chaînes…",
      "noCopyFrom": "Aucune chaîne trouvée",
      "chainNameExists": "Une chaîne portant ce nom existe déjà",
      "legibleNameExists": "Une chaîne portant ce nom d'affichage existe déjà"
    },
    "dialog": {
      "createTitle": "Créer une chaîne",
      "duplicateTitle": "Dupliquer une chaîne"
    },
    "info": {
      "fields": {
        "displayName": "Nom affiché",
        "chainName": "Nom de la chaîne",
        "defaultTimeZone": "Fuseau horaire par défaut",
        "status": "Statut",
        "stores": "Magasins"
      },
      "storeSummary": "{{active}} actifs sur {{total}}"
    },
    "compare": {
      "title": "Comparer les paramètres",
      "onlyDiffs": "Différences",
      "noDifferences": "Aucune différence trouvée",
      "dialog": {
        "title": "Comparer les paramètres de chaîne",
        "description": "Sélectionnez deux chaînes pour comparer leurs paramètres.",
        "sourceLabel": "Chaîne source",
        "targetLabel": "Comparer avec",
        "pickChain": "Choisir une chaîne…",
        "compare": "Comparer"
      }
    },
    "notifications": {
      "created": "Chaîne \"{{name}}\" créée",
      "updated": "Chaîne \"{{name}}\" mise à jour"
    },
    "storeCount_one": "{{count}} magasin",
    "storeCount_other": "{{count}} magasins",
    "regions": {
      "columns": {
        "regionName": "Nom de la région",
        "storesCount": "Magasins"
      }
    }
  },
  "stores": {
    "title": "Magasins",
    "missingDataWarning": "Des données du magasin sont manquantes, veuillez les renseigner et enregistrer.",
    "list": {
      "columns": {
        "id": "ID",
        "legibleName": "Nom",
        "chain": "Chaîne",
        "storeName": "Clé",
        "storeCode": "Code magasin",
        "regionName": "Région",
        "timezone": "Fuseau horaire",
        "status": "Statut"
      },
      "actions": {
        "duplicate": "Dupliquer",
        "deactivate": "Désactiver",
        "activate": "Activer",
        "archive": "Archiver",
        "compareSettings": "Comparer les paramètres",
        "tools": "Outils",
        "triggerShc": "Récupérer SHC depuis l'API"
      },
      "searchPlaceholder": "Rechercher des magasins...",
      "filter": {
        "chain": "Chaîne",
        "region": "Région",
        "searchRegions": "Rechercher des régions…",
        "noRegions": "Aucune région trouvée"
      },
      "addStoreButton": "Créer un magasin"
    },
    "dialog": {
      "createTitle": "Créer un magasin",
      "duplicateTitle": "Dupliquer un magasin",
      "deactivateTitle": "Désactiver le magasin",
      "activateTitle": "Activer le magasin",
      "deactivatePrompt": "Voulez-vous vraiment désactiver",
      "deactivateConsequencesIntro": "Cela va :",
      "deactivateConsequence1": "Désactiver toutes les caméras du magasin",
      "deactivateConsequence2": "Empêcher les utilisateurs assignés au magasin de se connecter",
      "activatePrompt": "Voulez-vous vraiment activer",
      "deactivateConfirm": "Désactiver",
      "activateConfirm": "Activer"
    },
    "form": {
      "legibleName": "Nom d'affichage",
      "storeName": "Nom du magasin",
      "storeCode": "Code du magasin",
      "chainName": "Chaîne",
      "timeZone": "Fuseau horaire",
      "copySettings": "Copier les paramètres d'un magasin existant",
      "selectChain": "Sélectionner une chaîne",
      "searchChains": "Rechercher des chaînes…",
      "noChains": "Aucune chaîne trouvée",
      "selectTimezone": "Sélectionner un fuseau horaire",
      "searchTimezones": "Rechercher des fuseaux horaires…",
      "noTimezones": "Aucun fuseau horaire trouvé",
      "selectCopyFrom": "Sélectionner un magasin source",
      "searchCopyFrom": "Rechercher des magasins…",
      "noCopyFrom": "Aucun magasin trouvé",
      "notSet": "Non défini",
      "goLiveDate": "Date de mise en service",
      "cannotChangeAfterCreation": "Ne peut pas être modifié après la création",
      "address": "Adresse",
      "city": "Ville",
      "state": "État",
      "zipCode": "Code postal",
      "country": "Pays",
      "region": "Région",
      "selectCountry": "Sélectionner un pays",
      "searchCountries": "Rechercher des pays…",
      "noCountries": "Aucun pays trouvé",
      "selectRegion": "Sélectionner une région",
      "searchRegions": "Rechercher des régions…",
      "noRegions": "Aucune région trouvée"
    },
    "cameraCount_one": "{{count}} appareil",
    "cameraCount_other": "{{count}} appareils",
    "compare": {
      "title": "Comparer les paramètres",
      "onlyDiffs": "Différences",
      "noDifferences": "Aucune différence trouvée",
      "dialog": {
        "title": "Comparer les paramètres de magasin",
        "description": "Sélectionnez deux magasins pour comparer leurs paramètres.",
        "sourceLabel": "Magasin source",
        "targetLabel": "Comparer avec",
        "pickStore": "Choisir un magasin…",
        "compare": "Comparer"
      }
    },
    "notifications": {
      "created": "Magasin \"{{name}}\" créé",
      "updated": "Magasin \"{{name}}\" mis à jour"
    },
    "info": {
      "wipBanner": "En cours de développement — bientôt disponible",
      "fields": {
        "displayName": "Nom affiché",
        "storeName": "Nom du magasin",
        "storeCode": "Code magasin",
        "chain": "Chaîne",
        "goLiveDate": "Date de mise en service",
        "status": "Statut",
        "address": "Adresse",
        "city": "Ville",
        "state": "État",
        "zipCode": "Code postal",
        "country": "Pays",
        "region": "Région",
        "timeZone": "Fuseau horaire",
        "openTime": "Heure d'ouverture",
        "closeTime": "Heure de fermeture",
        "deviceType": "Type d'appareil",
        "cameras": "Appareils",
        "cameraOnTime": "Caméras allumées",
        "cameraOffTime": "Caméras éteintes"
      },
      "cameraCountSummary": "{{active}} actives sur {{total}}",
      "storeDetails": {
        "title": "Détails du magasin"
      },
      "address": {
        "title": "Adresse"
      },
      "hours": {
        "title": "Horaires"
      },
      "impactSettings": {
        "title": "Paramètres Impact"
      },
      "matchSettings": {
        "title": "Paramètres de correspondance"
      },
      "scheduleSettings": {
        "title": "Paramètres du calendrier"
      }
    },
    "operations": {
      "fields": {
        "storeHours": "Heures d'ouverture",
        "cameraHours": "Heures de caméras",
        "priorityLogic": "Logique de priorité",
        "sortingLogic": "Logique de tri",
        "minWorkable": "Minimum traitable",
        "isPromoOnTop": "Promo en premier",
        "isAssociatesCanSort": "Les associés peuvent trier",
        "isShowDsdItems": "Afficher les articles DSD",
        "isShowNonWorkable": "Afficher non traitables",
        "isHidePog": "Masquer POG",
        "isDisableIngress": "Désactiver l'ingress",
        "isExcludeFromQueue": "Exclure de la file",
        "isDiscrepDisableIngress": "Désactiver l'ingress discrep",
        "cooldownHours": "Heures de pause"
      },
      "selectPriorityLogic": "Sélectionner la logique de priorité",
      "selectSortingLogic": "Sélectionner la logique de tri",
      "searchOption": "Rechercher…",
      "noOption": "Aucune option trouvée",
      "notifications": {
        "updated": "Paramètres opérationnels mis à jour pour « {{name}} »"
      }
    },
    "hardware": {
      "fields": {
        "ssid": "SSID",
        "password": "Mot de passe",
        "username": "Nom d'utilisateur",
        "authMode": "Mode d'authentification",
        "timeout": "Délai d'attente (ms)",
        "otaVersion": "Version OTA ESP32",
        "sc25OtaVersion": "Version OTA SC25",
        "sc25OtaComponentVersion": "Version OTA SC25 ({{cpuType}} / {{firmwareType}})",
        "forceUnfreezeDevices": "Forcer l’attribution à tous les appareils",
        "overrideChainVersion": "Remplacer la version de la chaîne",
        "remoteUrl": "URL du récepteur d'image",
        "jpgQuality": "Qualité JPEG",
        "deploymentInterval": "Intervalle de déploiement",
        "streamingTime": "Temps de streaming (s)",
        "autoWhiteBalance": "Balance des blancs automatique"
      },
      "firmwareSection": "Firmware",
      "networkSection": "Réseau",
      "selectAuthMode": "Sélectionner le mode d'authentification",
      "selectOtaVersion": "Sélectionner la version OTA ESP32",
      "selectSc25OtaVersion": "Sélectionner la version OTA SC25",
      "forceUnfreezeDevicesHint": "Les configurations OTA par appareil seront remplacées",
      "notifications": {
        "updated": "Paramètres matériels mis à jour pour « {{name}} »"
      }
    },
    "map": {
      "title": "Carte du magasin",
      "noMap": "Aucune carte téléchargée pour ce magasin.",
      "uploadButton": "Télécharger une carte",
      "uploadSuccess": "Carte téléchargée avec succès",
      "zoomIn": "Zoom avant",
      "zoomOut": "Zoom arrière",
      "resetView": "Réinitialiser la vue"
    },
    "schedule": {
      "everyday": "Programme quotidien",
      "exceptions": "Exceptions",
      "noExceptions": "Aucune exception. Le programme quotidien s'applique tous les jours.",
      "legend": "Légende :",
      "copyEveryday": "Copier le quotidien",
      "addPinHint": "Cliquez sur la barre pour ajouter une heure de capture",
      "algorithmTimed": "{{count}} images/jour · planifié par algorithme",
      "capturesPerDay": "{{count}} images/jour",
      "fields": {
        "images": "Images",
        "awakeTime": "Réveil"
      },
      "strategies": {
        "every_hour": "Toutes les heures",
        "no_of_images": "N images/jour",
        "static": "Plages horaires",
        "strict": "Heures exactes"
      },
      "labels": {
        "model": "Modèle",
        "off": "Désactivé",
        "human": "Humain",
        "qr": "QR"
      },
      "popover": {
        "window": "Plage {{range}}",
        "slotAt": "Capture à {{time}}",
        "remove": "Supprimer"
      },
      "exception": {
        "addTitle": "Ajouter une exception",
        "editTitle": "Modifier l'exception",
        "subtitle": "Choisissez quand ce programme remplace le programme quotidien.",
        "scheduleHeading": "Programme d'exception",
        "name": "Nom",
        "tickets": "Tickets",
        "rule": "Règle",
        "ruleInvalid": "Syntaxe de règle invalide",
        "variables": "Variables disponibles"
      },
      "notifications": {
        "updated": "Programme mis à jour pour « {{name}} »"
      },
      "mixedLabel": "Mixte",
      "add": "Ajouter"
    },
    "cutOffTimes": {
      "searchPlaceholder": "Rechercher des heures limites...",
      "noCutOffTimes": "Aucune heure limite",
      "everyDay": "Tous les jours",
      "default": "Par défaut",
      "localTimeNote": "Heures exprimées dans l'heure locale du magasin",
      "useCases": {
        "reporting": "Reporting",
        "impact": "Impact"
      },
      "scopes": {
        "store": "magasin",
        "chain": "chaîne"
      },
      "filter": {
        "useCase": "Cas d'usage",
        "scope": "Niveau"
      },
      "columns": {
        "id": "ID",
        "cutOffTime": "Heure",
        "useCase": "Cas d'usage",
        "dayOfWeek": "Jours",
        "department": "Rayon",
        "taskType": "Type de tâche",
        "isDefault": "Par défaut",
        "scope": "Défini sur"
      },
      "days": {
        "mon": "Lun",
        "tue": "Mar",
        "wed": "Mer",
        "thu": "Jeu",
        "fri": "Ven",
        "sat": "Sam",
        "sun": "Dim"
      },
      "addButton": "Ajouter une heure limite",
      "form": {
        "createTitle": "Ajouter une heure limite",
        "editTitle": "Modifier l'heure limite",
        "chainWideWarning": "S'applique à tous les magasins de la chaîne, sauf si un magasin la remplace par sa propre heure limite.",
        "cutOffTime": "Heure",
        "useCase": "Cas d'usage",
        "days": "Jours",
        "department": "Rayon",
        "taskType": "Type de tâche",
        "isDefault": "Par défaut",
        "isDefaultHint": "Utiliser comme heure limite principale pour cette condition",
        "everyDayHint": "aucune sélection — tous les jours",
        "notRequired": "facultatif",
        "validation": {
          "cutOffTimeRequired": "Choisissez une heure limite",
          "cutOffTimeStep": "Les heures limites vont par pas de 15 minutes"
        },
        "duplicate": "Une heure limite avec ces paramètres existe déjà pour ce magasin"
      },
      "notifications": {
        "created": "Heure limite ajoutée",
        "createFailed": "Impossible d'ajouter l'heure limite",
        "updated": "Heure limite mise à jour",
        "updateFailed": "Impossible de mettre à jour l'heure limite",
        "deleted": "Heure limite supprimée",
        "deleteFailed": "Impossible de supprimer l'heure limite"
      },
      "actions": {
        "edit": "Modifier",
        "delete": "Supprimer",
        "noChainPermissionHint": "Vous n'avez pas l'autorisation de modifier les heures limites de la chaîne",
        "noStorePermissionHint": "Vous n'avez pas l'autorisation de modifier les heures limites de ce magasin"
      },
      "deleteDialog": {
        "title": "Supprimer l'heure limite ?",
        "description": "L'heure limite {{useCase}} à {{time}} sera supprimée. Cette action est irréversible.",
        "chainWideWarning": "Il s'agit d'une heure limite au niveau de la chaîne. La supprimer modifie le comportement de tous les magasins de la chaîne qui n'en définissent pas.",
        "confirm": "Supprimer"
      }
    },
    "bulkCreate": {
      "title": "Créer des magasins en masse",
      "sheet": "Feuille",
      "uploadPrompt": "Importer un tableur",
      "uploadHint": "XLSX, XLS ou CSV — la première ligne doit contenir les en-têtes de colonnes",
      "selectColumn": "Sélectionner une colonne",
      "noColumn": "— Aucune —",
      "unnamedColumn": "Colonne {{index}}",
      "rowCount": "{{count}} lignes",
      "previewNote": "Affichage de {{shown}} sur {{total}} lignes",
      "validSummary": "{{valid}} valides · {{invalid}} avec problèmes",
      "rowColumn": "Ligne",
      "errorColumn": "Erreur",
      "creating": "Création des magasins…",
      "createdCount": "{{count}} créés",
      "failedCount": "{{count}} échoués",
      "createButton": "Créer {{count}} magasins",
      "downloadFailures": "Télécharger les échecs",
      "back": "Retour",
      "errors": {
        "noSheets": "Aucune feuille trouvée dans le fichier",
        "parseFailed": "Impossible de lire le fichier",
        "createFailed": "Échec de la création",
        "missing": "{{field}} est requis",
        "unknownChain": "Chaîne ‘{{chain}}’ introuvable",
        "dupCode": "Code magasin en double ‘{{code}}’",
        "requiredUnmapped": "Associez tous les champs requis (*) pour continuer",
        "badTime": "{{field}} « {{raw}} » n’est pas une heure valide",
        "timeOrder": "L’heure d’ouverture ne doit pas être après l’heure de fermeture",
        "hoursFailed": "Impossible de relire le magasin pour appliquer les horaires",
        "hoursUnavailable": "Horaires ignorés — les données d’exploitation du magasin sont indisponibles",
        "patchFailed": "Échec de la mise à jour complémentaire",
        "cameraTimeOrder": "L’heure d’activation des caméras ne doit pas être après l’heure d’arrêt"
      },
      "mode": {
        "column": "Colonne",
        "constant": "Valeur",
        "computed": "Calculé"
      },
      "computedHint": "Dérivé : chain_storeCode",
      "valuePlaceholder": "Saisir une valeur",
      "next": "Suivant",
      "selectedSummary": "{{selected}} sur {{total}} sélectionnés",
      "existsSummary": "{{count}} existent déjà",
      "invalidSummary": "{{count}} invalides",
      "selectAll": "Tout sélectionner",
      "searchColumns": "Rechercher des colonnes…",
      "noColumns": "Aucune colonne trouvée",
      "appendCode": "+ (code magasin)",
      "selectSheet": "Sélectionner une feuille",
      "searchSheets": "Rechercher des feuilles…",
      "noSheetsFound": "Aucune feuille trouvée",
      "includeAddress": "Inclure l’adresse",
      "active": "Actif",
      "includeHours": "Inclure les horaires du magasin et des caméras",
      "patchFailedCount": "{{count}} mises à jour complémentaires échouées",
      "patchIssue": "Magasin créé, mise à jour complémentaire échouée : {{error}}",
      "skippedCount": "{{count}} ignorés",
      "skippedExists": "Ignoré — le magasin existe déjà"
    },
    "tools": {
      "menuLabel": "Outils",
      "bulkCreate": "Créer des magasins en masse"
    }
  },
  "storeHealth": {
    "refreshAll": "Tout actualiser",
    "refreshPanel": "Actualiser {{panel}}",
    "lastChecked": "Dernière vérification {{time}}",
    "retry": "Réessayer",
    "panelError": "Impossible de charger ce panneau.",
    "noReferenceStore": "Aucun magasin de référence n'est configuré pour cette enseigne, il n'y a donc rien à comparer.",
    "searchPlaceholder": "Rechercher une table ou un paramètre…",
    "clearSearch": "Effacer la recherche",
    "onlyDifferences": "Différences uniquement ({{count}})",
    "noRows": "Rien à afficher.",
    "status": {
      "pass": "Conforme",
      "warn": "Alerte",
      "fail": "Échec",
      "info": "Info",
      "skip": "Ignoré"
    },
    "origin": {
      "canon": "Canon",
      "reference": "Référence",
      "store-only": "Magasin uniquement"
    },
    "columns": {
      "check": "Contrôle",
      "status": "Statut",
      "value": "Valeur",
      "threshold": "Seuil",
      "setting": "Paramètre",
      "expected": "Attendu",
      "storeValue": "Valeur du magasin"
    },
    "panels": {
      "identity": {
        "title": "Identité et configuration",
        "description": "Configuration physique et identité du magasin."
      },
      "cameras": {
        "title": "Caméras et modèles",
        "description": "Diffusion des caméras, dérive des modèles et tâches de scan en attente."
      },
      "planograms": {
        "title": "Planogrammes et catalogue",
        "description": "Couverture des planogrammes et qualité du catalogue."
      },
      "imports": {
        "title": "Imports",
        "description": "Flux clients entrants et fraîcheur des capacités de rayon."
      },
      "settingsDiff": {
        "title": "Écart de paramètres et configuration",
        "description": "Comparé à <store/>. Diagnostic — pas un verdict conforme/échec.",
        "descriptionGeneric": "Comparé au magasin de référence de l'enseigne. Diagnostic — pas un verdict conforme/échec."
      }
    }
  },
  "dataTable": {
    "noResults": "Aucun résultat.",
    "showing": "Affichage {{from}}-{{to}} sur {{total}}",
    "noResultsCount": "Aucun résultat",
    "rows": "{{count}} lignes",
    "export": "Exporter",
    "resetColumns": "Réinitialiser",
    "allTimesIn": "Heures en <tz/>"
  },
  "common": {
    "loading": "Chargement…",
    "useValue": "Utiliser « {{value}} »",
    "noResults": "Aucun résultat trouvé",
    "copiedToClipboard": "Copié dans le presse-papiers :",
    "active": "Actif",
    "workInProgress": "En cours de développement…",
    "createdAt": "Créé",
    "updatedAt": "Mis à jour",
    "clear": "Effacer",
    "fileTypeNotAccepted": "Seuls les fichiers {{types}} sont acceptés"
  },
  "passkeys": {
    "title": "Passkeys",
    "description": "Les passkeys vous permettent de vous connecter avec votre empreinte, votre visage ou le code de votre appareil, sans mot de passe.",
    "empty": "Aucune passkey pour l'instant. Ajoutez-en une pour vous connecter plus vite la prochaine fois.",
    "namePlaceholder": "Nom de la passkey (ex. MacBook Touch ID)",
    "add": "Ajouter une passkey",
    "adding": "Configuration…",
    "registered": "Passkey ajoutée",
    "revoke": "Révoquer",
    "revoked": "Passkey révoquée",
    "added": "Ajoutée le {{date}}",
    "lastUsed": "dernière utilisation {{date}}",
    "neverUsed": "jamais utilisée",
    "deviceType": {
      "multi_device": "Synchronisée",
      "single_device": "Cet appareil"
    },
    "error": "Une erreur s'est produite. Veuillez réessayer.",
    "revokeDialog": {
      "title": "Révoquer la passkey",
      "prompt": "Êtes-vous sûr de vouloir révoquer",
      "warning": "Cette passkey ne pourra plus être utilisée pour se connecter. Cette action est irréversible.",
      "confirm": "Révoquer"
    }
  },
  "settings": {
    "title": "Paramètres",
    "columns": {
      "name": "Nom",
      "key": "Clé",
      "setting": "Paramètre"
    },
    "info": {
      "title": "Informations du paramètre",
      "showMore": "Afficher plus",
      "showLess": "Afficher moins",
      "fields": {
        "key": "Clé",
        "name": "Nom",
        "description": "Description",
        "noDescription": "Aucune description",
        "group": "Groupe",
        "type": "Type",
        "defaultValue": "Valeur par défaut",
        "chainOverrides": "Remplacements de chaîne",
        "storeOverrides": "Remplacements de magasin"
      }
    },
    "list": {
      "columns": {
        "id": "ID",
        "name": "Nom",
        "key": "Clé",
        "groupName": "Groupe",
        "fieldType": "Type",
        "defaultValue": "Par défaut",
        "chainOverrides": "Remplacements de chaîne",
        "storeOverrides": "Remplacements de magasin",
        "value": "Valeur",
        "source": "Source",
        "status": "Statut"
      },
      "filter": {
        "overridesOnly": "Remplacements",
        "group": "Groupe",
        "searchGroups": "Rechercher des groupes…",
        "noGroups": "Aucun groupe trouvé",
        "chainOverrides": "Remplacements de chaîne",
        "storeOverrides": "Remplacements de magasin"
      },
      "searchPlaceholder": "Rechercher des paramètres...",
      "actions": {
        "edit": "Modifier",
        "restoreDefault": "Restaurer la valeur par défaut"
      },
      "editDialog": {
        "title": "Modifier le paramètre",
        "nameLabel": "Nom",
        "keyLabel": "Clé",
        "defaultValueLabel": "Valeur par défaut",
        "valueLabel": "Valeur",
        "selectPlaceholder": "Sélectionner une valeur",
        "selectSearchPlaceholder": "Rechercher des valeurs…",
        "noValues": "Aucune valeur",
        "invalidNumber": "Doit être un nombre valide",
        "cancel": "Annuler",
        "save": "Enregistrer"
      },
      "restoreDialog": {
        "title": "Restaurer la valeur par défaut",
        "description": "Êtes-vous sûr de vouloir restaurer \"{{name}}\" à sa valeur par défaut ?",
        "cancel": "Annuler",
        "confirm": "Restaurer"
      },
      "toast": {
        "updated": "Paramètre \"{{name}}\" mis à jour",
        "updateError": "Échec de la mise à jour du paramètre",
        "restored": "Paramètre \"{{name}}\" restauré à la valeur par défaut",
        "restoreError": "Échec de la restauration du paramètre"
      },
      "jsonPreview": {
        "description": "Cet aperçu est formaté pour la lisibilité. La valeur originale est stockée minifiée.",
        "copy": "Copier"
      }
    },
    "chains": {
      "columns": {
        "id": "ID",
        "name": "Chaîne",
        "value": "Valeur",
        "status": "Statut"
      },
      "searchPlaceholder": "Rechercher des chaînes…"
    },
    "stores": {
      "columns": {
        "id": "ID",
        "store": "Magasin",
        "chain": "Chaîne",
        "value": "Valeur",
        "status": "Statut"
      },
      "searchPlaceholder": "Rechercher des magasins…"
    },
    "status": {
      "override": "remplacement",
      "default": "par défaut",
      "store": "magasin",
      "chain": "chaîne"
    }
  },
  "imports": {
    "importData": "Importer des données",
    "importCsv": "Importer un CSV",
    "searchPlaceholder": "Rechercher des imports…",
    "columns": {
      "id": "ID",
      "publicId": "ID publique",
      "timestamp": "Créé",
      "type": "Type",
      "createdBy": "Téléversé par",
      "store": "Magasin",
      "source": "Source",
      "processingTime": "Temps de traitement",
      "status": "Statut",
      "validationTime": "Temps de validation",
      "queueingTime": "Temps d'attente",
      "itemsFound": "Éléments trouvés",
      "productsFound": "Produits trouvés",
      "productsCreated": "Produits créés",
      "productsUpdated": "Produits mis à jour",
      "productsZeroed": "Produits remis à zéro",
      "storeCode": "Code du magasin",
      "items": "Éléments",
      "createdAt": "Créé"
    },
    "actions": {
      "retrigger": "Relancer",
      "downloadJson": "Télécharger le fichier JSON",
      "downloadCsv": "Télécharger le fichier CSV",
      "copyRawJson": "Copier le chemin JSON brut",
      "copyRawCsv": "Copier le chemin CSV brut",
      "downloadError": "Impossible de générer le lien de téléchargement"
    },
    "retrigger": {
      "title": "Relancer l'import",
      "prompt": "Réexécutez cet import. Utile après un échec.",
      "confirm": "Relancer",
      "success": "Import #{{id}} mis en file pour relance",
      "errorTitle": "Impossible de relancer l'import",
      "errors": {
        "missingContent": "L'import #{{id}} n'a pas de fichier JSON préparé et ne peut pas être relancé.",
        "notFound": "L'import #{{id}} est introuvable."
      },
      "includeSubsequent": {
        "label": "Relancer également les imports suivants",
        "hint": "Réexécute dans l'ordre les imports ultérieurs du même type pour ce magasin."
      }
    },
    "csv": {
      "title": "Importer un CSV",
      "typeLabel": "Type d'import",
      "typePlaceholder": "Sélectionnez un type d'import…",
      "types": {
        "metadata": "Métadonnées",
        "boh": "Stock disponible",
        "sales": "Ventes",
        "pricing": "Prix"
      },
      "fileLabel": "Fichier CSV",
      "fileDropTitle": "Déposez un fichier CSV ou cliquez pour téléverser",
      "overrideStoreCode": "Remplacer le code magasin",
      "uploadingPercent": "Téléversement… {{percent}}%",
      "processing": "Conversion des lignes…",
      "upload": "Téléverser",
      "success": "Import #{{id}} créé avec {{count}} éléments",
      "errorTitle": "Impossible d'importer ce fichier",
      "moreErrors": "…et {{count}} de plus"
    },
    "wizard": {
      "title": "Importer des données",
      "submitButton": "Soumettre l'import",
      "submittedSuccess": "Import soumis avec succès",
      "inactiveTransformation": {
        "title": "Cette transformation est désactivée",
        "hint": "Vous pouvez quand même soumettre un import, mais la cohérence et la fiabilité des données importées ne sont pas garanties."
      },
      "steps": {
        "scope": "Périmètre",
        "transformation": "Transformation",
        "upload": "Téléversement",
        "validate": "Validation",
        "preview": "Aperçu"
      },
      "scope": {
        "selectChain": "Sélectionner une chaîne…",
        "searchChains": "Rechercher des chaînes…",
        "noChains": "Aucune chaîne trouvée",
        "selectStore": "Sélectionner un magasin (optionnel)…",
        "searchStores": "Rechercher des magasins…",
        "noStores": "Aucun magasin trouvé"
      },
      "transformation": {
        "select": "Sélectionner une transformation…",
        "search": "Rechercher des transformations…",
        "empty": "Aucune transformation trouvée",
        "filesToPrepare": "Fichiers à préparer"
      },
      "upload": {
        "startingSession": "Démarrage de la session d'import…",
        "uploadingPercent": "Téléversement… {{percent}}%",
        "processing": "Traitement…",
        "dropFile": "Déposez un fichier ou cliquez pour téléverser ({{fileType}})"
      },
      "validate": {
        "validating": "Validation des fichiers…",
        "errorsTitle": "Erreurs de validation trouvées",
        "errorsCount": "{{errors}} erreurs dans {{files}} fichiers",
        "errorColumn": "(colonne : {{column}})",
        "errorRow": "à la ligne {{location}}"
      },
      "preview": {
        "submitting": "Soumission de l'import…",
        "preparing": "Préparation des requêtes d'import…",
        "preparingProgress": "Préparation du magasin {{current}} sur {{total}}…",
        "submittingProgress": "Création de la requête d'import {{current}} sur {{total}}…",
        "filesProcessed": "Fichiers traités",
        "validFiles": "Fichiers valides",
        "totalRecords": "Enregistrements totaux",
        "storesAffected": "Magasins concernés",
        "estDuration": "Durée est.",
        "storeCodes": "Codes magasin traités",
        "importRequests": "Requêtes d'import",
        "itemsCount": "{{count}} éléments"
      }
    }
  },
  "tabs": {
    "info": "Infos",
    "health": "Santé",
    "edit": "Modifier",
    "permissions": "Autorisations",
    "boPermissions": "Autorisations BO",
    "users": "Utilisateurs",
    "chains": "Chaînes",
    "stores": "Magasins",
    "map": "Carte",
    "settings": "Paramètres",
    "operations": "Opérations",
    "schedule": "Planification",
    "cutOffTimes": "Heures limites",
    "devices": "Appareils",
    "hardware": "Matériel",
    "imports": "Importations",
    "security": "Sécurité",
    "activityLog": "Activité",
    "usage": "Utilisation"
  },
  "profile": {
    "title": "Mon profil",
    "edit": {
      "wip": "La modification de votre profil n'est pas encore disponible."
    },
    "security": {
      "sso": {
        "title": "Compte à authentification unique",
        "description": "Vous vous connectez via le fournisseur d'identité de votre organisation (SSO). Votre mot de passe, vos passkeys et l'authentification à deux facteurs y sont gérés et ne peuvent pas être configurés ici."
      },
      "password": {
        "title": "Mot de passe",
        "description": "Modifiez le mot de passe que vous utilisez pour vous connecter.",
        "current": "Mot de passe actuel",
        "new": "Nouveau mot de passe",
        "confirm": "Confirmer le nouveau mot de passe",
        "submit": "Changer le mot de passe",
        "submitting": "Modification…",
        "success": "Mot de passe modifié",
        "required": "Ce champ est obligatoire",
        "tooShort": "Utilisez au moins 8 caractères",
        "mismatch": "Les nouveaux mots de passe ne correspondent pas",
        "invalid": "Votre mot de passe actuel est incorrect",
        "error": "Impossible de changer votre mot de passe. Veuillez réessayer."
      },
      "mfa": {
        "title": "Authentification à deux facteurs",
        "description": "Ajoutez une couche de sécurité supplémentaire avec une application d'authentification.",
        "statusLabel": "Application d'authentification",
        "enabledStatus": "Activée",
        "setup": "Configurer la double authentification",
        "disable": "Désactiver",
        "setupTitle": "Configurer l'authentification à deux facteurs",
        "setupDescription": "Scannez le QR code avec votre application d'authentification, puis saisissez le code à 6 chiffres pour confirmer.",
        "qrAlt": "QR code de double authentification",
        "secretLabel": "Ou saisissez cette clé de configuration manuellement",
        "codeLabel": "Code de vérification",
        "enable": "Activer",
        "enabled": "Authentification à deux facteurs activée",
        "invalidCode": "Ce code ne correspond pas. Veuillez réessayer.",
        "generateError": "Impossible de démarrer la configuration. Veuillez réessayer.",
        "disableTitle": "Désactiver l'authentification à deux facteurs",
        "disableConfirm": "Votre compte ne nécessitera plus de code de vérification à la connexion. Êtes-vous sûr ?",
        "disabled": "Authentification à deux facteurs désactivée",
        "disableError": "Impossible de désactiver la double authentification. Veuillez réessayer."
      }
    },
    "settings": {
      "appearance": {
        "title": "Apparence",
        "description": "Thème, langue et format de date pour cet appareil."
      },
      "theme": {
        "label": "Thème"
      },
      "accent": {
        "label": "Couleur d’accent",
        "options": {
          "green": "Vert",
          "red": "Rouge",
          "blue": "Bleu"
        }
      },
      "language": {
        "label": "Langue",
        "hint": "S’applique uniquement aux libellés et aux messages — le format de date n’est pas modifié."
      },
      "dateFormat": {
        "label": "Format de date",
        "hint": "S’applique à toutes les dates de l’application. « Système » suit les paramètres régionaux de votre système d’exploitation.",
        "options": {
          "system": "Système",
          "dmy": "Jour en premier",
          "mdy": "Mois en premier",
          "iso": "Année en premier (ISO)"
        }
      },
      "tables": {
        "title": "Tableaux",
        "description": "Valeurs par défaut des listes et tableaux."
      },
      "itemsPerPage": {
        "label": "Éléments par page",
        "hint": "Appliqué à chaque tableau lors de sa prochaine ouverture."
      },
      "integrations": {
        "title": "Intégrations",
        "description": "Connectez vos comptes à Focal."
      },
      "slack": {
        "label": "Nom d'utilisateur Slack",
        "placeholder": "@votre.identifiant",
        "hint": "Enregistré sur votre compte.",
        "save": "Enregistrer",
        "saved": "Nom d'utilisateur Slack enregistré",
        "saveError": "Impossible d'enregistrer votre nom d'utilisateur Slack. Veuillez réessayer."
      },
      "advanced": {
        "title": "Avancé",
        "description": "Options de diagnostic et de réinitialisation."
      },
      "diagnostics": {
        "title": "Diagnostics",
        "description": "Outils de développement et de QA pour cet appareil."
      },
      "httpErrorToasts": {
        "label": "Afficher les toasts d'erreur HTTP",
        "hint": "Afficher un toast avec les détails de la requête et de la réponse à chaque échec d'un appel API (422, 5xx ou erreur réseau). Utile pour la QA et le débogage."
      },
      "reset": {
        "title": "Réinitialiser les préférences",
        "description": "Effacer tous les paramètres locaux de l'appareil et rétablir les valeurs par défaut.",
        "button": "Réinitialiser les préférences locales",
        "toast": "Préférences réinitialisées",
        "dialog": {
          "title": "Réinitialiser les préférences locales ?",
          "description": "Cela efface le thème, la langue, les dispositions de tableaux et autres paramètres locaux, puis recharge l'application. Votre compte et votre connexion ne sont pas affectés.",
          "cancel": "Annuler",
          "confirm": "Réinitialiser"
        }
      }
    }
  },
  "activity": {
    "searchPlaceholder": "Rechercher l'activité...",
    "empty": "Aucune activité trouvée",
    "wipBanner": "En cours de développement — données simulées",
    "filter": {
      "timeRange": "Période",
      "onlyChain": "Chaîne uniquement"
    }
  },
  "buttons": {
    "cancel": "Annuler",
    "create": "Créer",
    "save": "Sauvegarder",
    "discard": "Ignorer",
    "stayOnPage": "Rester sur la page",
    "discardAndLeave": "Ignorer et quitter",
    "schedule": "Planifier",
    "submitForApproval": "Soumettre pour approbation",
    "back": "Retour",
    "next": "Suivant",
    "validate": "Valider",
    "edit": "Modifier",
    "done": "Terminé",
    "close": "Fermer"
  },
  "unsavedChanges": {
    "title": "Modifications non enregistrées",
    "description": "Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir quitter ? Vos modifications seront perdues."
  },
  "notifications": {
    "title": "Notifications",
    "empty": "Aucune notification",
    "wipBanner": "En cours de développement — données simulées",
    "markAllRead": "Tout marquer comme lu",
    "markRead": "Marquer comme lu",
    "dismiss": "Ignorer",
    "actions": {
      "review": "Examiner",
      "approve": "Approuver"
    },
    "mock": {
      "importFailed": {
        "title": "Import échoué pour Lidl DE #4012",
        "description": "L'import du catalogue produits a échoué en raison de colonnes obligatoires manquantes. Vérification manuelle nécessaire."
      },
      "settingApproval": {
        "title": "Modification de paramètre en attente d'approbation",
        "description": "\"camera_resolution\" a été modifié sur Aldi Süd — Berlin Mitte. En attente de votre approbation."
      },
      "importComplete": {
        "title": "Import terminé avec succès",
        "description": "Import de planogramme pour Carrefour FR terminé — 847 articles traités."
      },
      "storeOffline": {
        "title": "Caméras du magasin hors ligne",
        "description": "3 caméras chez Tesco UK — Manchester Central sont hors ligne depuis plus de 2 heures."
      },
      "userCreated": {
        "title": "Nouvel utilisateur créé",
        "description": "L'utilisateur \"m.schmidt@lidl.com\" a été créé et assigné à Lidl DE."
      },
      "settingUpdated": {
        "title": "Paramètre mis à jour",
        "description": "Valeur par défaut de \"detection_threshold\" modifiée de 0,7 à 0,75."
      }
    }
  },
  "header": {
    "commands": "Commandes..."
  },
  "approvals": {
    "title": "Approbations",
    "tabs": {
      "pending": "En attente",
      "resolved": "Traitées"
    },
    "status": {
      "pending": "En attente",
      "approved": "Approuvée",
      "rejected": "Rejetée",
      "executed": "Exécutée",
      "failed": "Échouée"
    },
    "actions": {
      "approve": "Approuver",
      "reject": "Rejeter"
    },
    "actionTypes": {
      "create-chain": "Créer une chaîne"
    },
    "scheduleForLater": "Planifier pour plus tard",
    "requestedExecutionTime": "Heure d'exécution souhaitée (après approbation)",
    "scheduledFor": "Planifié pour {{time}}",
    "scheduledForFooter": "Planifié pour : {{time}}",
    "requestedBy": "Demandé par {{name}}",
    "resolvedBy": "{{action}} par {{name}}",
    "rejectionReason": "Raison (facultatif)",
    "rejectDescription": "Fournissez une raison facultative pour le rejet de cette action.",
    "submitDialog": {
      "title": "Soumettre pour approbation",
      "titleWithAction": "Soumettre \"{{action}}\" pour approbation",
      "description": "Vérifiez les détails ci-dessous. Un administrateur devra approuver cette action avant son exécution.",
      "scheduleHint": "Laissez vide pour exécuter immédiatement après approbation.",
      "messagePlaceholder": "Message à l'approbateur (facultatif)"
    },
    "clearSchedule": "Effacer",
    "noActions": "Aucune action en attente",
    "wipBanner": "En cours de développement — données simulées",
    "noResolvedActions": "Aucune action traitée",
    "notifications": {
      "scheduled": "\"{{name}}\" a été planifié",
      "submittedForApproval": "\"{{name}}\" soumis pour approbation"
    }
  },
  "commandPalette": {
    "placeholder": "Saisir une commande ou rechercher...",
    "empty": "Aucun résultat trouvé.",
    "pages": "Pages",
    "settings": "Paramètres",
    "commands": "Commandes",
    "profile": "Profil",
    "myProfile": "Mon profil",
    "debug": "Débogage",
    "logout": "Déconnexion",
    "back": "Retour",
    "footer": {
      "navigate": "Naviguer",
      "select": "Sélectionner",
      "goBack": "Retour",
      "close": "Fermer"
    },
    "createChain": "Créer une chaîne",
    "createStore": "Créer un magasin",
    "createUser": "Créer un utilisateur",
    "createVendor": "Créer un fournisseur",
    "createTransformation": "Créer une transformation",
    "importData": "Importer des données",
    "compareChainSettings": "Comparer les paramètres de chaîne",
    "compareStoreSettings": "Comparer les paramètres de magasin",
    "refreshView": "Actualiser la vue actuelle",
    "featureFlags": "Indicateurs de fonctionnalité",
    "telemetry": "Télémétrie API",
    "showcase": "Galerie de composants",
    "flagOn": "activé",
    "flagOff": "désactivé",
    "telemetryClearAll": "Tout effacer",
    "telemetryEmpty": "Aucune requête enregistrée.",
    "theme": {
      "title": "Changer le thème",
      "placeholder": "Sélectionner un thème...",
      "light": "Clair",
      "dark": "Sombre",
      "system": "Système"
    },
    "accent": {
      "title": "Changer la couleur d’accent",
      "placeholder": "Sélectionner une couleur d’accent..."
    },
    "language": {
      "title": "Changer la langue",
      "placeholder": "Sélectionner une langue..."
    },
    "createOctoRule": "Créer une règle Octo",
    "createFirmwareVersion": "Créer une version de firmware"
  },
  "octoRules": {
    "title": "Règles Octo",
    "unnamed": "Règle #{{id}}",
    "unnamedShort": "Sans nom",
    "scopeGlobal": "Global",
    "list": {
      "columns": {
        "id": "ID",
        "name": "Nom",
        "scope": "Portée",
        "stage": "Étape",
        "outcome": "Résultat",
        "priority": "Priorité",
        "createdAt": "Créé",
        "status": "Statut"
      },
      "searchPlaceholder": "Rechercher des règles…",
      "filter": {
        "chain": "Chaîne",
        "store": "Magasin",
        "stage": "Étape",
        "searchStages": "Rechercher des étapes…",
        "noStages": "Aucune étape trouvée"
      },
      "actions": {
        "activate": "Activer",
        "deactivate": "Désactiver"
      },
      "addRuleButton": "Créer une règle"
    },
    "stage": {
      "creation": "Création",
      "visibility": "Visibilité",
      "workability": "Réalisabilité"
    },
    "outcome": {
      "allow": "Autoriser",
      "deny": "Refuser"
    },
    "fields": {
      "name": "Nom",
      "description": "Description",
      "scope": "Portée",
      "stage": "Étape",
      "outcome": "Résultat",
      "priority": "Priorité",
      "predicate": "Règle",
      "tickets": "Tickets",
      "startDate": "Date de début",
      "endDate": "Date de fin",
      "status": "Actif",
      "createdAt": "Créé",
      "updatedAt": "Mis à jour"
    },
    "detail": {
      "tabs": {
        "info": "Infos",
        "edit": "Modifier",
        "activity": "Activité"
      }
    },
    "edit": {
      "updated": "Règle « {{name}} » mise à jour",
      "predicateInvalid": "Expression CEL invalide",
      "predicateUnknownProperty": "Propriété non reconnue",
      "variables": "Variables",
      "allowedValues": "Valeurs autorisées",
      "predicateInvalidValue": "Valeur invalide",
      "predicateDecimalExpected": "Valeur décimale attendue",
      "predicateRuntimeTypeError": "Échouera à l'évaluation",
      "predicateObjectNotValue": "Objet, pas une valeur",
      "availableFields": "Champs disponibles",
      "fields": "Champs de {{variable}}"
    },
    "dialog": {
      "activateTitle": "Activer la règle",
      "deactivateTitle": "Désactiver la règle",
      "activatePrompt": "Voulez-vous vraiment activer",
      "deactivatePrompt": "Voulez-vous vraiment désactiver",
      "activateConfirm": "Activer",
      "deactivateConfirm": "Désactiver",
      "deactivateWarning": "Cette règle ne sera plus appliquée par Octo tant qu'elle est inactive.",
      "createTitle": "Créer une règle",
      "created": "Règle « {{name}} » créée"
    },
    "form": {
      "chain": "Chaîne",
      "store": "Magasin",
      "scopeLabel": "Portée",
      "selectChain": "Sélectionner une chaîne…",
      "selectStore": "Sélectionner un magasin…"
    },
    "tools": {
      "menuLabel": "Outils",
      "evaluate": "Évaluer les règles"
    },
    "evaluate": {
      "title": "Évaluer les règles",
      "contextTitle": "Contexte d'évaluation",
      "contextHint": "Choisissez un type de tâche pour exécuter la chaîne. Ajoutez un produit et une heure pour évaluer par rapport à eux.",
      "taskType": "Type de tâche",
      "selectTaskType": "Sélectionner un type de tâche…",
      "searchTaskTypes": "Rechercher des types de tâche…",
      "noTaskTypes": "Aucun type de tâche trouvé",
      "evaluatedAt": "Date et heure actuelles",
      "product": {
        "upc": "UPC",
        "itemNumber": "Numéro article",
        "upcPlaceholder": "UPC du produit",
        "itemNumberPlaceholder": "Numéro d'article"
      },
      "timezoneHint": "Les heures sont lues en heure locale du magasin ({{timezone}}). Laisser vide pour maintenant.",
      "timezoneHintGeneric": "Les heures sont lues en heure locale du magasin. Laisser vide pour maintenant.",
      "pickStore": "Choisissez un magasin pour voir les règles parcourues.",
      "running": "Évaluation…",
      "failed": "Échec de l'évaluation",
      "noRules": "Aucune règle ne s'applique à ce magasin et à cette étape.",
      "runButton": "Évaluer",
      "stoppedHere": "L'évaluation s'est arrêtée ici",
      "priorityLabel": "priorité {{priority}}",
      "noPredicate": "Pas de prédicat — s'applique toujours",
      "outOfDateRange": "Hors de sa période de validité, mais évaluée quand même — le moteur ignore ces dates.",
      "outcomeTitle": "Résultat",
      "outcomeNone": "Indéterminé",
      "scope": {
        "global": "Global",
        "chain": "Enseigne",
        "store": "Magasin"
      },
      "evaluation": {
        "matched": "Correspond",
        "notMatched": "Aucune correspondance",
        "fallback": "Repli",
        "skippedInactive": "Inactive",
        "notReached": "Non atteinte",
        "error": "Erreur",
        "notEvaluated": "Non évaluée"
      },
      "reason": {
        "ruleMatched": "Décidé par « {{rule}} » — la première règle dont le prédicat correspond.",
        "fallbackRule": "Décidé par « {{rule}} » — une règle sans prédicat, elle s'applique toujours.",
        "implicitFallback": "Aucune règle ne correspond. Le moteur se replie sur le refus.",
        "compileError": "Les règles de cette étape n'ont pas pu être compilées, aucune n'a été exécutée.",
        "evaluationError": "L'évaluation a échoué en cours de route, aucune décision n'a été prise.",
        "noRules": "Aucune règle active pour ce magasin et cette étape — le moteur n'intervient pas.",
        "notEvaluated": "Pas encore évaluée. Choisissez un type de tâche et cliquez sur Évaluer."
      },
      "effect": {
        "creation": {
          "allow": "La tâche serait créée.",
          "deny": "La tâche serait supprimée et jamais créée."
        },
        "visibility": {
          "allow": "La tâche serait visible dans le magasin.",
          "deny": "La tâche serait masquée dans le magasin."
        },
        "workability": {
          "allow": "La tâche serait réalisable.",
          "deny": "La tâche ne serait pas réalisable."
        }
      },
      "debug": {
        "compiledRule": "Chaîne de règles compilée",
        "boundContext": "Contexte lié",
        "empty": "Vide"
      }
    }
  },
  "devices": {
    "title": "Appareils",
    "list": {
      "columns": {
        "id": "ID",
        "name": "Nom",
        "store": "Magasin",
        "chain": "Enseigne",
        "createdAt": "Créé",
        "lastImage": "Dernière image",
        "lastStatus": "Dernier statut",
        "status": "Statut"
      },
      "searchPlaceholder": "Rechercher des appareils...",
      "filter": {
        "chain": "Enseigne",
        "store": "Magasin"
      }
    }
  },
  "firmware": {
    "title": "Firmware",
    "list": {
      "columns": {
        "id": "ID",
        "version": "Version",
        "versionNum": "Build",
        "deviceType": "Appareil",
        "cpuType": "CPU",
        "firmwareType": "Firmware",
        "production": "Production",
        "createdAt": "Créé",
        "status": "Statut"
      },
      "searchPlaceholder": "Rechercher des versions...",
      "filter": {
        "deviceType": "Type d'appareil",
        "searchDeviceTypes": "Rechercher des types d'appareil…",
        "noDeviceTypes": "Aucun type d'appareil trouvé",
        "cpuType": "Type de CPU",
        "searchCpuTypes": "Rechercher des types de CPU…",
        "noCpuTypes": "Aucun type de CPU trouvé",
        "production": "Production"
      },
      "addButton": "Créer une version"
    },
    "fields": {
      "versionStr": "Version",
      "versionNum": "Numéro de build",
      "deviceType": "Type d'appareil",
      "cpuType": "Type de CPU",
      "fileUri": "URI du fichier",
      "md5": "MD5",
      "changeLog": "Journal des modifications",
      "createdAt": "Créé",
      "updatedAt": "Mis à jour",
      "file": "Fichier firmware"
    },
    "production": {
      "ready": "production",
      "draft": "brouillon"
    },
    "actions": {
      "activate": "Activer",
      "deactivate": "Désactiver",
      "markProduction": "Marquer prêt pour la production",
      "unmarkProduction": "Retirer le marqueur production"
    },
    "dialog": {
      "activateTitle": "Activer la version",
      "deactivateTitle": "Désactiver la version",
      "activatePrompt": "Voulez-vous vraiment activer",
      "deactivatePrompt": "Voulez-vous vraiment désactiver",
      "deactivateWarning": "Les appareils ne recevront plus ce firmware tant qu'il est inactif.",
      "activateConfirm": "Activer",
      "deactivateConfirm": "Désactiver",
      "markProductionTitle": "Marquer prêt pour la production",
      "unmarkProductionTitle": "Retirer le marqueur production",
      "markProductionPrompt": "Marquer comme prêt pour la production",
      "unmarkProductionPrompt": "Retirer le marqueur de production de",
      "markProductionConfirm": "Marquer prêt",
      "unmarkProductionConfirm": "Retirer",
      "createTitle": "Créer une version de firmware",
      "created": "Version « {{name}} » créée",
      "productionLabel": "Prêt pour la production",
      "fileHint": "Téléversez le binaire du firmware ({{ext}})",
      "fileDropTitle": "Déposez le fichier firmware ou cliquez pour parcourir",
      "cpuPlaceholder": "Sélectionner le type de CPU",
      "fileHintArchive": "Téléversez l'archive du firmware ({{ext}})",
      "createFailed": "Impossible de créer la version du firmware. Veuillez réessayer.",
      "versionExists": "Cette version existe déjà pour le type d'appareil sélectionné",
      "fileRequired": "Sélectionnez un fichier firmware à téléverser",
      "buildNumberExists": "Ce numéro de build existe déjà pour le type d'appareil sélectionné"
    },
    "detail": {
      "tabs": {
        "info": "Info",
        "assignments": "Affectations"
      }
    },
    "assignments": {
      "empty": "Aucune chaîne, magasin ou appareil n'est affecté à cette version.",
      "frozen": "Figé",
      "columns": {
        "scope": "Portée",
        "target": "Cible",
        "frozen": "Figé",
        "assignedAt": "Affecté",
        "id": "ID"
      },
      "scope": {
        "device": "Appareil",
        "store": "Magasin",
        "chain": "Chaîne"
      },
      "searchPlaceholder": "Rechercher des affectations...",
      "searchScopes": "Rechercher des portées…",
      "noScopes": "Aucune portée trouvée"
    }
  },
  "updateAvailable": {
    "message": "Une nouvelle version est disponible.",
    "reload": "Recharger"
  }
}
